"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FrozenTemp = function FrozenTemp(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 23.49",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.91,19V11.79a1.36,1.36,0,0,0-2.72,0V19a2.45,2.45,0,1,0,2.72,0Zm-1.36,2.92a.81.81,0,0,1-.27-1.58V14.58a.27.27,0,0,1,.54,0v5.76a.81.81,0,0,1-.27,1.58Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.44,15l-.69-.37L19,13.84,18.3,12.6l-2,1.22-.5-.27V9.94l.5-.27,2,1.22L19,9.66l-1.29-.78,1-.54,2,1.22.74-1.24-1.3-.78,1-.53-.68-1.27-1, .52.09-1.49-1.44-.08L18.1,7.06l-1,.54.09-1.49L15.73,6,15.59,8.4l-.48.26L11.5,6.24v-.6l2-1.23-.75-1.23-1.28.78V2.8l2-1.23L12.77.33l-1.28.78V0H10.05V1.12L8.76.34, 8,1.58l2,1.23V4L8.76,3.18,8,4.42l2,1.23v.59L6.44,8.66,6,8.4,5.82,6l-1.44.08.09,1.49-1-.54L3.32,4.69l-1.44.08L2,6.27,1,5.75.31,7l1,.53L0,8.33.74,9.56l2-1.22,1, .54-1.3.78.74,1.24,2-1.22.5.27v3.62l-.5.27-2-1.22-.74,1.24,1.3.78-1,.54-2-1.22L0,15.17,1.3,16l-1,.53L1,17.75l1-.52-.09,1.49,1.44.08.14-2.37,1-.54-.09,1.49, 1.44.08L6,15.1l.48-.25,3.61,2.42v.58L8,19.07l.74,1.24,1.29-.78v1.15L8,21.91l.74,1.24,1.29-.78v1.12H11.5V22.38l1.28.78.75-1.23-2-1.23V19.54l1.28.78.75-1.23-2-1.23v-.59l3.62-2.42.48.25.14, 2.37,1.44-.08-.09-1.49.68.36Zm-4.11-1.35L10.78,16,7.23,13.64V9.86l3.55-2.37,3.55,2.37Z"
  }));
};

var _default = FrozenTemp;
exports["default"] = _default;